import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { fetchWorkspaceExportDownloadUrl } from '@/api/workspaceExport/workspaceExportApi';
import { WORKSPACE_EXPORT_QUERY_KEY } from '@/constants/queryKeys';

export function useDownloadWorkspaceExportMutation(): UseMutationResult<string, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchWorkspaceExportDownloadUrl,
    onSuccess: function openDownloadUrl(downloadUrl) {
      window.location.assign(downloadUrl);
    },
    onError: function refreshExportState() {
      queryClient.invalidateQueries({ queryKey: WORKSPACE_EXPORT_QUERY_KEY });
    },
  });
}
